import { TreinamentosRequest, TreinamentosResponse } from '../../types/cliente/treinamentos/types'
import { formatDate } from '../../utils/utils'
import { Contact } from '../../types/cliente/contatos/types';
import { ReleasedVersionsRequest, ReleasedVersionsResponse } from '../../types/cliente/versoes/types'
import { api } from '../api'
import { CustomerFeedbackRequest, FeedbackRequest, PesquisaSatisfacao } from '../../types/cliente/feedback/feedback';


export const fetchTreinametos = async ({ idCliente, filters }: TreinamentosRequest): Promise<TreinamentosResponse> => {
  const url = `/clientes/${idCliente}/treinamentos`

  const { data } = await api.get<TreinamentosResponse>(url, {
    params: {
      ...filters,
      dataInicial: formatDate(filters.dataInicial),
      dataFinal: formatDate(filters.dataFinal),
    },
  })

  return data
}


export const fetchPesquisaSatisfacao = async (tipoAtendimento: string): Promise<PesquisaSatisfacao> => {
  const url = `/clientes/perguntaspesquisasatisfacao`

  const { data } = await api.get<PesquisaSatisfacao>(url, {
    params: {
      tipoAtendimento,
    },
  })

  return data
}


export const fetchContatos = async (idCliente: number): Promise<Contact[]> => {
  const url = `/clientes/${idCliente}/contatos`

  const { data } = await api.get<Contact[]>(url)
  return data
}

export const fetchVersoesLiberadas = async ({ idCliente, filters }: ReleasedVersionsRequest): Promise<ReleasedVersionsResponse> => {
  const url = `/clientes/${idCliente}/versoesliberadas`

  const { data } = await api.get<ReleasedVersionsResponse>(url, {
    params: {
      ...filters,
      dataInicial: formatDate(filters.dataInicial),
      dataFinal: formatDate(filters.dataFinal),
      dataInicialLiberacao: formatDate(filters.dataInicialLiberacao),
      dataFinalLiberacao: formatDate(filters.dataFinalLiberacao),
    },
  })

  return data
}


export const cadastrarRetornoCliente = async (form: FeedbackRequest) => {
  const url = `/clientes/retornoCliente`;

  const { data } = await api.post(url, {
      ...form
  });

  return data;
};


export const cadastrarRepostaCliente = async (form: CustomerFeedbackRequest) => {
  const url = `/clientes/respostaCliente`;

  const { data } = await api.post(url, {
      ...form
  });

  return data;
};